import React, { useEffect, useState } from 'react';
import "./styles.sass"

export interface Props {
    maxChar: number;
    onChange: (val: string) => void;
    header: string;
    helperText: string;
    value: string;
};

/**
 * TODO: Describe this component!
 */
const MvCharCnt = ({
    maxChar,
    onChange,
    header,
    helperText,
    value,
}: Props) => {
    const [textAreaValue, setTextAreaValue] = useState<string>(value);

    useEffect(() => {
        onChange(textAreaValue);
    }, [textAreaValue, onChange]);

    const remainingCount = maxChar - (textAreaValue ? textAreaValue.length : 0);
    const getCharacterLabel = (count: number): string => {
        if (count === 1) {
            return '1 character';
        } else {
            return `${count} characters`;
        }
    }

    return (
        <div className='mv-char-cnt'>
            <h3>{header}</h3>
            <p>{helperText}</p>
            <textarea
                value={textAreaValue}
                onChange={e => setTextAreaValue(e.target.value)}
                rows={5}
                maxLength={maxChar}
            />
            <p className='char-limit'>
                <span className='char-limit-message'>Please limit messages to {getCharacterLabel(maxChar)}, including spaces.</span>
                <span className={`char-remaining ${remainingCount < 1 ? 'char-remaining-red' : ''}`}>{getCharacterLabel(remainingCount)} remaining</span>
            </p>
        </div>
    );
};

export {
    MvCharCnt,
};
